import { Injectable } from '@angular/core';
import {environment} from "@env/environment";
import {debounceTime, distinctUntilChanged, filter, map, Observable} from "rxjs";
import {Exchanges, ExchangesRegion} from "@interfaces/model/exchanges.interface";
import {DropDownOption} from "@interfaces/common/form.interface";
import {HttpClient} from "@angular/common/http";
import {
  UniverseItem,
  UniverseRequestParams,
  UniverseResponse,
  UniverseSearchRequestParams
} from "@interfaces/model/universe.interface";
import {UserLoginEventsRequestParams, UserLoginEventsResponse} from "@interfaces/model/user-login-events";

@Injectable({
  providedIn: 'root'
})
export class UniverseService {

  apiURL = environment.apiEndpoint;

  constructor(private http: HttpClient) { }

  getAll(params?: UniverseRequestParams): Observable<UniverseResponse> {
    let query = [];
    for (let key in params) {
      // @ts-ignore
      query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
    }
    const url = `${this.apiURL}/admin/universe${(query.length ? '?' + query.join('&') : '')}`;
    return this.http.get<UniverseResponse>(url);
  };

  getById(id: number): Observable<UniverseItem> {
    const url = `${this.apiURL}/admin/universe/id/${id}`;
    return this.http.get<UniverseItem>(url);
  };

  getAllWithSearch(params?: UniverseSearchRequestParams): Observable<UniverseResponse> {
    let query = [];
    for (let key in params) {
      // @ts-ignore
      query.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
    }
    const url = `${this.apiURL}/admin/universe/search${(query.length ? '?' + query.join('&') : '')}`;
    return this.http.get<UniverseResponse>(url);
  };

  searchSymbols(query: string): Observable<DropDownOption[]> {
    const url = `${this.apiURL}/universe?query=${query}`;
    return this.http.get<any[]>(url).pipe(
      map((symbols) => {
        symbols.sort((a, b) => a.ricsIdentifier.localeCompare(b.ricsIdentifier));
        return symbols.filter(d => d.isActive).map(item => {
          return {
            name: item.ricsIdentifier,
            value: item
          }
        })
      }
    ));
  }

  delete(id: number): Observable<any> {
    const url = `${this.apiURL}/admin/universe/${id}`;
    return this.http.delete<any>(url);
  };

  update(data: UniverseItem, id: number): Observable<any> {
    const url = `${this.apiURL}/admin/universe/${id}`;
    return this.http.put<any>(url,data);
  };

  add(data: UniverseItem): Observable<any> {
    const url = `${this.apiURL}/admin/universe`;
    return this.http.post<any>(url,data);
  }
}
